import { Box, useColorModeValue } from "@chakra-ui/react";
import React, { Dispatch, SetStateAction } from "react";
import TabSwitcher from "../TabSwitcher";
import FormLoadingOverlay from "../common-quote/FormLoadingOverlay";
import FormTabsContainer from "../common-quote/FormTabsContainer";
import Discussion from "../common-quote/Discussion";
import QuoteOverrideContent from "./QuoteOverrideContent";
import QuoteCalcInfo from "./QuoteCalcInfo";
import { RentalQuote } from "../../lib/models/rental/rental.model";
import { FixAndFlipQuote } from "../../lib/models/short-term/short-term.model";
import { FormSectionStatus } from "../../lib/models/form-section-status.model";
import { FixAndFlipForm } from "../../lib/models/short-term/short-term-form.model";
import { QuoteFormActions } from "../../lib/types/QuoteFormActions";
import { CalculationType } from "../../state/quote-reducer";
import { lightMode, darkMode } from "../../lib/models/color-mode-colors";

export interface QuoteFormTabsProps {
  isCalculating: boolean | undefined;
  quoteTabs: string[];
  setTabIndex: React.Dispatch<React.SetStateAction<number>>;
  tabIndex: number;
  formStatusSections: FormSectionStatus[];
  calculation: CalculationType;
  isFnf: boolean;
  quote: FixAndFlipQuote | RentalQuote | null;
  formActionHandler: (action: QuoteFormActions, values: FixAndFlipForm) => void;
  preferredLoanAmt: number | undefined;
  setPreferredLoanAmt: Dispatch<SetStateAction<number | undefined>> | undefined;
}

const QuoteFormTabs = (props: QuoteFormTabsProps) => {
  const bgColor = useColorModeValue(lightMode[100], darkMode[200]);
  return (
    <>
      {props.isCalculating && (
        <FormLoadingOverlay label="Calculating Quote..." />
      )}
      <Box
        paddingY={{ base: 2, lg: 4 }}
        paddingX={{ base: 2, lg: 8 }}
        background={bgColor}
        borderTopRadius={{ base: 8, lg: 0 }}
        borderBottomRadius={8}
        boxShadow="sm"
      >
        <Box>
          {props.quoteTabs.length > 1 && (
            <Box
              marginBottom={{ base: 4, lg: 0 }}
              display={{ base: "block", lg: "none" }}
            >
              <TabSwitcher
                activeIndex={0}
                tabItems={props.quoteTabs}
                onTabClick={(index) => props.setTabIndex(index)}
              />
            </Box>
          )}
          <FormTabsContainer
            tabIndex={props.tabIndex}
            formStatusSections={props.formStatusSections}
            calculation={props.calculation}
            overrideContent={
              <QuoteOverrideContent
                isFnf={props.isFnf}
                calculation={props.calculation}
                quote={props.quote}
                formActionHandler={props.formActionHandler}
                preferredLoanAmt={props.preferredLoanAmt}
              />
            }
            calcInfo={
              <QuoteCalcInfo
                isFnf={props.isFnf}
                calculation={props.calculation}
                setPreferredLoanAmt={props.setPreferredLoanAmt}
              />
            }
            discussionContent={<Discussion />}
            isFnf={props.isFnf}
          />
        </Box>
      </Box>
    </>
  );
};

export default QuoteFormTabs;
